import React from 'react'
import GlassPanel from '../UI/GlassPanel'

const Tile = ({ icon, value, label, hint }) => (
  <GlassPanel className="p-5">
    <div className="text-center">
      <div className="text-2xl mb-1">{icon}</div>
      <div className="text-3xl font-bold text-white mb-1 tabular-nums">{value}</div>
      <div className="text-sm text-gray-300">{label}</div>
      {hint && <div className="text-xs text-gray-500 mt-1">{hint}</div>}
    </div>
  </GlassPanel>
)

/**
 * The numbers worth leading with.
 *
 * `totalSets` and `distinctArtists` are deliberately both shown — seeing 40
 * artists once is a different history from seeing 10 artists four times, and
 * either number alone hides that.
 */
const HeadlineStats = ({ headlines = {}, eventsByYear = [] }) => {
  const {
    totalEvents = 0,
    pastEvents = 0,
    upcomingEvents = 0,
    totalDays = 0,
    distinctArtists = 0,
    totalSets = 0
  } = headlines

  const peak = eventsByYear.reduce(
    (best, year) => (year.count > (best?.count || 0) ? year : best),
    null
  )

  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Tile icon="🎉" value={totalEvents} label="Events"
              hint={upcomingEvents > 0 ? `${pastEvents} past · ${upcomingEvents} upcoming` : null} />
        <Tile icon="📅" value={totalDays} label="Days at events" />
        <Tile icon="🎤" value={distinctArtists} label="Artists seen"
              hint={totalSets > distinctArtists ? `${totalSets} sets total` : null} />
        <Tile icon="⭐" value={peak ? peak.year : '—'} label="Biggest year"
              hint={peak ? `${peak.count} events` : null} />
      </div>

      {eventsByYear.length > 1 && (
        <GlassPanel className="p-6 mb-8">
          <h2 className="text-lg font-semibold text-white mb-4">Events by year</h2>
          <div className="flex items-end gap-2 h-32">
            {eventsByYear.map(year => {
              const tallest = Math.max(...eventsByYear.map(y => y.count))
              return (
                <div key={year.year} className="flex-1 flex flex-col items-center gap-1 min-w-0">
                  <span className="text-xs text-gray-400 tabular-nums">{year.count}</span>
                  <div
                    className="w-full bg-gradient-to-t from-purple-600 to-pink-500 rounded-t"
                    style={{ height: `${Math.max(8, (year.count / tallest) * 100)}%` }}
                    title={`${year.year}: ${year.count} events`}
                  />
                  <span className="text-xs text-gray-400 truncate w-full text-center">{year.year}</span>
                </div>
              )
            })}
          </div>
        </GlassPanel>
      )}
    </>
  )
}

export default HeadlineStats
